module.exports = __webpack_public_path__ + "226d96a7ba468bb74ba5a8efcf31a89a.png";